










































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {GCICategoryListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import {PDCDataReq, PostDeleteContentsReq} from '@/model/dto/req/contents/post-delete-contents-req';
import {CategoryInfoInterface} from '@/model/interfaces/category-interface';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';
import {HTMLElementEvent} from '@/model/interfaces/extends-interface';

@Component({
  components: {}
})
export default class DetailViewer extends Vue {

  private time: number = 1000;

  /** Refs **/
  public $refs!: {
    'contentsText': HTMLElement
  };

  /** Data **/
  /** Computed **/
  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get contents() {
    return detailModule.contents;
  }

  get feedbackComment() {
    return detailModule.contents.feedback ?? [];
  }

  get contentsTitle() {
    let title: string = detailModule.contents.title_new !== null && detailModule.contents.title_new !== '' ? detailModule.contents.title_new : detailModule.contents.title;
    title = this.userId === '' || this.userId !== detailModule.contents.user_id && this.isAuthorityNumber >= this.Instructor ? detailModule.contents.title : title;
    return title;
  }

  get contentsText() {
    let text: string = detailModule.contents.text_new !== null && detailModule.contents.text_new !== '' ? detailModule.contents.text_new : detailModule.contents.text;
    text = this.userId === '' || this.userId !== detailModule.contents.user_id && this.isAuthorityNumber >= this.Instructor ? detailModule.contents.text : text;
    const hashtag = contentsService.hashtagExtraction(text); // hashtagのリスト
    const token = this.$route.query.token ?? userModule.apiToken;
    const replaceText = contentsService.addAnchrInTag(text, {path: '/s', token: token as string}); // hashtagをリンク化
    return replaceText;
  }

  get userId() {
    return userModule.userId;
  }

  get userType() {
    return userModule.type;
  }

  get isAuthorityNumber() {
    return userService.isAuthorityNumber(userModule.type);
  }

  get Learner() {
    return AuthorityNum.Learner;
  }

  get Instructor() {
    return AuthorityNum.Instructor;
  }

  get deleteStatus() {
    return contentsModule.deleteStatus;
  }

  get formatDate() {
    const date = this.contents.published !== (null || undefined) ? this.contents.published : this.contents.created;
    return date ? date : '';
  }

  get isLogin() {
    return userModule.userName !== '' && appModule.token !== '';
  }

  get text() {
    return {
      edit: GlobalConstants.TEXT.EDIT,
      delete: GlobalConstants.TEXT.DELETE,
      deleteConfirm: GlobalConstants.TEXT.DELETECONFIRMATION,
      created: GlobalConstants.TEXT.CREATED
    };
  }

  /** Methods **/
  private onEdit() {
    const token = this.$route.query.token ?? userModule.apiToken;
    contentsModule.pushIsEditMode(true);
    const info = _.find(appModule.categorySelectInfo, (val: GCICategoryListRes) => {
      return _.includes(this.$route.path.slice(1).split('/'), String(val.category_type));
    });

    if (info === undefined ) { return; }
    const path = `c/${info.category_type}/edit/${detailModule.contents.content_id}`;
    this.$router.push({
      path: `/${path}`
    }).catch(err => err);
  }

  private onDelete() {
    const contentId = detailModule.contents.content_id;
    const params: PDCDataReq = {
      contentId
    };
    appModule.startLoading();
    const func = _.debounce(async () => {
      await appModule.updateIsDeleteConfirmationDialog({
        type: 'delete',
        state: true,
        title: `${this.text.delete}`,
        message: `${this.text.deleteConfirm}`,
        data: Object.assign(params, {isDelete: true})
      });
      appModule.stopLoading();
    }, this.time);
    func();
  }

  private async onClickHashTag(e: HTMLElementEvent<HTMLInputElement>): Promise<void> {
    if (e.target.innerText.match(/#/) !== null) {
      e.preventDefault();
      e.stopPropagation();
    }
    const token = this.$route.query.token ?? userModule.apiToken;
    if (e.target !== null) {
      const path = `s/${e.target.className}`;
      if (e.target.className && e.target.className !== '' && e.target.tagName === 'A' && e.target.innerText.match(/#/) !== null) {
        this.$router.push({
          path: `/${path}`,
          query: {
            searchtype: 'hashtag'
          }
        }).catch(err => err);
      }
    }
  }

  private onHtmlInContentsText() {
    this.$refs.contentsText.addEventListener(
      'click',
      {handleEvent: (e: HTMLElementEvent<HTMLInputElement>) => {
        this.onClickHashTag(e);
      }},
    );
  }

  private async callApi() {
    const token = this.$route.query.token ?? userModule.apiToken;
    await appModule.requestCategorySelectInfo(this.$route.params.category).catch(err => {
      this.errorPropagation(err);
    });
    await detailModule.requestContentsDetailInfo(this.$route.params.id).catch(err => {
      this.errorPropagation(err);
    });
    let categoryId = detailModule.contents.category_id;
    let categoryType = detailModule.contents.category_type;
    let categoryName = detailModule.contents.category_name;
    let categoryOrder = 0;
    if (appModule.categorySelectInfo.length > 0) {
      categoryId = appModule.categorySelectInfo[0].category_id;
      categoryType = appModule.categorySelectInfo[0].category_type;
      categoryName = appModule.categorySelectInfo[0].category_name;
      categoryOrder = appModule.categorySelectInfo[0].category_order;
    }
    this.onHtmlInContentsText();
    const srcArray = contentsService.srcExtraction(this.contentsText);
    appModule.updateMeta({
      title: this.contentsTitle,
      image: srcArray[0] ?? `${process.env.VUE_APP_BASE_URL}images/logo/logo.png`,
      updated_time: this.formatDate,
      description: contentsService.truncateString(contentsService.contentsTextRegex(this.contentsText), 40)
    });
    contentsService.setBreadcrumb(this.$route.path, 'detail', categoryType, categoryName, categoryOrder, null, `${token}`); // 現在のパンくず情報をセット
  }

  /** Watch **/
  @Watch('contents')
  private async onContents() {
    /*
    await detailModule.postReadLog(detailModule.contents.content_id).catch(err => {
      this.errorPropagation(err);
    });
    */
  }

  /** Watch **/
  @Watch('deleteStatus')
  private doDeleteStatus() {
    const token = this.$route.query.token ?? userModule.apiToken;
    const path = `/`;
    this.$router.push({ path: `${path}` }).catch(err => err);
  }

  @Watch('$route')
  private async onChangeRoute(to: any, from: {path: string}): Promise<void> {
    if (to.name === 'detail-viewer') {
      appModule.startLoading();
      this.callApi();
      appModule.stopLoading();
    }
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/
  private async created() {
    appModule.startLoading();
    this.callApi();
    appModule.stopLoading();
  }

}
